import { selectDateTimePickerSettings } from 'Config/configSlice';
import { useAppSelector } from 'Store';

export const useDateTimeConfigFromConfigSlice = () => {
  const dateTimePickerSettings = useAppSelector(selectDateTimePickerSettings);

  return {
    dateFormat: dateTimePickerSettings.dateFormat,
    timeFormat: dateTimePickerSettings.timeFormat,
    displayMode: dateTimePickerSettings.displayMode,
    timeStep: dateTimePickerSettings.timeStep,
    mondayFirst: dateTimePickerSettings.mondayFirst
  };
};
